import React from 'react';
import PropTypes from 'prop-types';

const HardToken = ({ height }) => (
  <svg
    height={`${height}px`}
    width="100%"
    version="1.1"
    viewBox={`0 0 160 ${height}`}
  >
    <defs>
      <rect height="216" id="path-2" width="149.85" rx="2.965248" x="0" y="0" />
      <polygon
        id="path-3"
        points="0 0 13.2242202 0 13.2242202 7.1410789 0 7.1410789"
      />
      <polygon
        id="path-5"
        points="0 15.5805358 21.4005666 15.5805358 21.4005666 0 0 0"
      />
    </defs>
    <g id="Page-1" fill="none" stroke="none" strokeWidth="1">
      <g
        id="B_Authorise-Payment"
        transform="translate(-666.000000, -739.000000)"
      >
        <g id="Group" transform="translate(671.000000, 741.000000)">
          <g id="Rectangle">
            <rect height="216" width="149.85" rx="2.965248" x="0" y="0" />
            <rect
              height="215.325"
              width="149.175"
              rx="2.965248"
              stroke="#E1E1E1"
              strokeWidth="0.675"
              x="0.3375"
              y="0.3375"
            />
          </g>
          <rect
            height="210.6"
            id="Rectangle"
            width="136.35"
            fill="#FDFDFD"
            rx="2.965248"
            x="5.4"
            y="4.05"
          />
          <path
            id="Rectangle"
            d="M8.365248,4.05 L138.784752,4.05 L138.784752,4.05 C140.422413,4.05 141.75,5.37758675 141.75,7.015248 L141.75,62.1 L5.4,62.1 L5.4,7.015248 L5.4,7.015248 C5.4,5.37758675 6.72758675,4.05 8.365248,4.05 Z"
            fill="#F7F7F7"
          />
          <g id="Numbers" transform="translate(25.650000, 74.250000)">
            <g id="1">
              <ellipse
                id="Oval-2"
                cx="13.3266423"
                cy="13.4764679"
                fill="#F0F0F0"
                rx="13.3266423"
                ry="13.4764679"
              />
              <text
                fill="#000000"
                fontFamily=".AppleSystemUIFont"
                fontSize="7.527168"
              >
                <tspan x="11.4863877" y="16.1589804">
                  1
                </tspan>
              </text>
            </g>
            <g id="6" transform="translate(70.364671, 32.343523)">
              <ellipse
                id="Oval-2-Copy-4"
                cx="13.3266423"
                cy="13.4764679"
                fill="#F0F0F0"
                rx="13.3266423"
                ry="13.4764679"
              />
              <text
                fill="#000000"
                fontFamily=".AppleSystemUIFont"
                fontSize="7.527168"
              >
                <tspan x="11.0208856" y="16.1589804">
                  6
                </tspan>
              </text>
            </g>
            <g id="2" transform="translate(35.182336, 0.000000)">
              <ellipse
                id="Oval-2-Copy"
                cx="13.3266423"
                cy="13.4764679"
                fill="#F0F0F0"
                rx="13.3266423"
                ry="13.4764679"
              />
              <text
                fill="#000000"
                fontFamily=".AppleSystemUIFont"
                fontSize="7.527168"
              >
                <tspan x="10.9681598" y="16.1589804">
                  2
                </tspan>
              </text>
            </g>
            <g id="5" transform="translate(35.182336, 32.343523)">
              <ellipse
                id="Oval-2-Copy-3"
                cx="13.3266423"
                cy="13.4764679"
                fill="#F0F0F0"
                rx="13.3266423"
                ry="13.4764679"
              />
              <text
                fill="#000000"
                fontFamily=".AppleSystemUIFont"
                fontSize="7.527168"
              >
                <tspan x="11.0907177" y="16.1589804">
                  5
                </tspan>
              </text>
            </g>
            <g id="8" transform="translate(35.182336, 64.687046)">
              <ellipse
                id="Oval-2-Copy-6"
                cx="13.3266423"
                cy="13.4764679"
                fill="#F0F0F0"
                rx="13.3266423"
                ry="13.4764679"
              />
              <text
                fill="#000000"
                fontFamily=".AppleSystemUIFont"
                fontSize="7.527168"
              >
                <tspan x="11.0153726" y="16.1589804">
                  8
                </tspan>
              </text>
            </g>
            <g id="0" transform="translate(35.182336, 97.030569)">
              <ellipse
                id="Oval-2-Copy-6"
                cx="13.3266423"
                cy="13.4764679"
                fill="#F0F0F0"
                rx="13.3266423"
                ry="13.4764679"
              />
              <text
                fill="#000000"
                fontFamily=".AppleSystemUIFont"
                fontSize="7.527168"
              >
                <tspan x="11.0484509" y="16.1589804">
                  0
                </tspan>
              </text>
            </g>
            <g id="4" transform="translate(0.000000, 32.343523)">
              <ellipse
                id="Oval-2-Copy-5"
                cx="13.3266423"
                cy="13.4764679"
                fill="#F0F0F0"
                rx="13.3266423"
                ry="13.4764679"
              />
              <text
                fill="#000000"
                fontFamily=".AppleSystemUIFont"
                fontSize="7.527168"
              >
                <tspan x="10.9969957" y="16.1589804">
                  4
                </tspan>
              </text>
            </g>
            <g id="7" transform="translate(0.000000, 64.687046)">
              <ellipse
                id="Oval-2-Copy-7"
                cx="13.3266423"
                cy="13.4764679"
                fill="#F0F0F0"
                rx="13.3266423"
                ry="13.4764679"
              />
              <text
                fill="#000000"
                fontFamily=".AppleSystemUIFont"
                fontSize="7.527168"
              >
                <tspan x="11.2744865" y="16.1589804">
                  7
                </tspan>
              </text>
            </g>
            <g id="*" fill="#F0F0F0" transform="translate(0.000000, 97.030569)">
              <ellipse
                id="Oval-2-Copy-7"
                cx="13.3266423"
                cy="13.4764679"
                rx="13.3266423"
                ry="13.4764679"
              />
            </g>
            <g id="3" transform="translate(70.364671, 0.000000)">
              <ellipse
                id="Oval-2-Copy-2"
                cx="13.3266423"
                cy="13.4764679"
                fill="#F0F0F0"
                rx="13.3266423"
                ry="13.4764679"
              />
              <text
                fill="#000000"
                fontFamily=".AppleSystemUIFont"
                fontSize="7.527168"
              >
                <tspan x="11.0594771" y="16.1589804">
                  3
                </tspan>
              </text>
            </g>
            <g id="9" transform="translate(70.364671, 64.687046)">
              <ellipse
                id="Oval-2-Copy-8"
                cx="13.3266423"
                cy="13.4764679"
                fill="#F0F0F0"
                rx="13.3266423"
                ry="13.4764679"
              />
              <text
                fill="#000000"
                fontFamily=".AppleSystemUIFont"
                fontSize="7.527168"
              >
                <tspan x="11.0208856" y="16.1589804">
                  9
                </tspan>
              </text>
            </g>
            <g
              id="#"
              fill="#F0F0F0"
              transform="translate(70.364671, 97.030569)"
            >
              <ellipse
                id="Oval-2-Copy-8"
                cx="13.3266423"
                cy="13.4764679"
                rx="13.3266423"
                ry="13.4764679"
              />
            </g>
          </g>
          <rect
            height="22.95"
            id="Rectangle-2"
            width="114.75"
            fill="#CBC46E"
            x="17.55"
            y="10.8"
          />
          <path
            id="002-power"
            d="M103.523941,185.069369 C103.347707,183.366691 104.158172,181.824394 105.502356,180.844531 C106.026373,180.462307 106.809965,180.789606 106.809965,181.393782 C106.809965,181.615734 106.692435,181.82 106.501389,181.958494 C105.548878,182.654917 104.975952,183.753419 105.115488,184.966165 C105.29674,186.54581 106.707035,187.824412 108.465113,188.000254 C110.75942,188.230885 112.708453,186.618312 112.708453,184.605829 C112.708453,183.538112 112.157533,182.582388 111.298036,181.956242 C111.107081,181.817858 110.991969,181.613482 110.991969,181.393782 C110.991969,180.796252 111.763349,180.457913 112.282347,180.831349 C113.511511,181.72119 114.3,183.081136 114.3,184.605829 C114.3,187.393826 111.660419,189.641361 108.50432,189.437095 C105.894152,189.27232 103.766407,187.407008 103.523941,185.069369 Z M108.713793,178.65 C108.301331,178.65 107.968966,178.971279 107.968966,179.365238 L107.968966,182.659762 C107.968966,183.055866 108.303565,183.375 108.713793,183.375 C109.12405,183.375 109.458621,183.053611 109.458621,182.659762 L109.458621,179.365238 C109.458621,178.971279 109.126284,178.65 108.713793,178.65 Z"
            fill="#13AE42"
          />
          <g id="001-left-arrow" transform="translate(32.400000, 179.550000)">
            <mask id="mask-4" fill="white">
              <polygon points="0 0 13.2242202 0 13.2242202 7.1410789 0 7.1410789" />
            </mask>
            <g id="Clip-2" />
            <path
              id="Fill-1"
              d="M12.6517826,3.07229599 L1.95436492,3.07229599 L4.50686145,0.850563059 C4.73059645,0.655973942 4.73059645,0.340387081 4.50686145,0.145941838 C4.28325042,-0.0486472793 3.92070384,-0.0486472793 3.69746474,0.145941838 L0.16770827,3.21829178 C-0.0559027568,3.41273703 -0.0559027568,3.72832389 0.16770827,3.92276913 L3.69746474,6.99526295 C3.80916694,7.09262945 3.95574767,7.1410789 4.1021631,7.1410789 C4.24857852,7.1410789 4.39511792,7.09262945 4.50686145,6.99526295 C4.73059645,6.80063787 4.73059645,6.48508697 4.50686145,6.29064173 L1.95436492,4.06872895 L12.6517826,4.06872895 C12.9678795,4.06872895 13.2242202,3.84561688 13.2242202,3.57053046 C13.2242202,3.29540806 12.9678795,3.07229599 12.6517826,3.07229599 Z"
              fill="#4A4A4A"
            />
          </g>
          <text
            id="MENU"
            fill="#000000"
            fontFamily=".AppleSystemUIFont"
            fontSize="3.649536"
          >
            <tspan x="34.2209865" y="203.8">
              MENU
            </tspan>
          </text>
          <text
            id="OK"
            fill="#000000"
            fontFamily=".AppleSystemUIFont"
            fontSize="3.649536"
          >
            <tspan x="107.986202" y="203.8">
              OK
            </tspan>
          </text>
          <g id="YB" transform="translate(102.600000, 39.150000)">
            <path
              id="Fill-1"
              d="M9.09702221,14.0905665 C11.8437732,14.1783433 15.0061845,13.3133582 17.3058887,11.9353474 C20.1849723,10.1772545 21.4005666,7.37436185 21.4005666,4.23825819 L21.4005666,0.370965138 L15.6033781,0.370965138 L15.6033781,4.12917632 C15.6033781,5.64183502 14.9620736,6.8630406 13.3443917,7.8422208 C12.5257954,8.30922754 11.552811,8.68675306 10.5586195,8.68675306 C9.42955044,8.68675306 8.40906202,8.3765515 7.56925859,7.75103517 C6.37571978,6.90905952 5.68606302,5.37339136 5.68606302,4.04054731 L5.68606302,0.370965138 L0,0.370965138 L0,4.12917632 C0,7.39737131 2.18179235,8.92622185 7.74739872,9.55514698 C9.47959933,9.74944906 11.2686351,9.73751823 13.0559743,9.14268118 C14.1180288,8.78816511 14.2376371,8.5802278 14.5642274,8.42086601 L14.6957117,8.55551394 L14.6091865,8.79668713 C13.9661855,10.5121699 12.5478508,11.8220045 11.0200872,12.600065 C9.05291132,13.6048113 6.68534428,13.5119213 4.51457965,13.2017197 L4.47131705,13.2017197 C5.33996222,13.7905913 8.19190073,14.0701136 9.09702221,14.0905665 L9.09702221,14.0905665 Z"
              fill="#1B63B7"
            />
            <path
              id="Fill-3"
              d="M13.6449548,5.7065542 C13.4502392,6.06067731 13.0456355,6.47270206 12.8222605,6.47270206 L12.7809572,6.46682798 C12.7008794,6.42151365 12.6612619,6.34850722 12.582027,6.21256423 C12.5103785,6.08249532 12.4092275,5.90627292 12.2288417,5.69900182 C12.002095,5.35914434 11.7686049,5.18208278 11.5966483,5.0570488 L11.4820106,4.96642014 L11.5098271,4.87495232 C11.6581818,4.6752336 11.7466889,4.42348732 11.7466889,4.14740557 L11.7466889,4.13649656 L11.77872,4.04083297 C12.1706799,4.00978426 12.5845558,3.92083391 12.8930662,3.79663908 C13.062494,3.72866758 13.1004256,3.70013634 13.1611161,3.65230454 C13.2007336,3.6145426 13.2673246,3.55999757 13.5387463,3.42069796 L13.7005878,3.37706194 C13.8447279,3.37706194 13.8910887,3.60699021 13.9307062,3.88307197 L13.9585227,4.03747636 C13.9559939,4.3303412 13.8978321,5.16697801 13.6449548,5.7065542 M11.5056633,7.47135794 L11.2131652,7.55890663 C10.9769814,7.58551456 10.7929093,7.59838937 10.6147209,7.59838937 C10.3474382,7.59838937 10.0801554,7.56577319 9.60526634,7.4696413 C9.3581559,7.42157535 8.9622749,7.2645027 9.00934355,6.99584839 C9.03203737,6.82933422 9.19173459,6.67311989 9.35647488,6.51261396 L9.63468425,6.21735171 C9.83136398,5.9778803 10.0162766,5.72982568 10.1381507,5.34701474 L10.2659085,5.34701474 C10.3743345,5.38392252 10.4911657,5.40881382 10.6105183,5.40881382 C10.7424786,5.40881382 10.8618313,5.38478084 10.9853865,5.34701474 L11.0627136,5.34701474 C11.130795,5.64141867 11.3451255,6.04225433 11.5485293,6.34352482 C11.6359426,6.46969793 11.7250368,6.57183807 11.8057259,6.66282004 C11.9687852,6.85508383 12.0494743,6.94949908 12.029302,7.08683036 C11.9830739,7.33488498 11.8242172,7.38810085 11.5056633,7.47135794 M8.49258534,6.10374495 C8.32748454,6.34311712 8.23502808,6.47000237 8.13184008,6.47270206 C7.85694724,6.42860718 7.57049734,6.18023606 7.39136297,5.82657717 C7.13958424,5.22814674 7.08179895,4.31385304 7.07932244,4.01868735 C7.1106916,3.54624227 7.18828897,3.37706194 7.37072536,3.37706194 L7.38393343,3.37706194 C7.5820544,3.4040588 7.69845047,3.47515054 7.8288801,3.5597407 C7.92794059,3.62273338 8.04103464,3.69472501 8.20200792,3.74961863 L8.22924956,3.75681779 C8.53633706,3.86570513 8.94578705,4.00158934 9.31065984,4.04568421 L9.3032303,4.14377281 C9.3032303,4.44703755 9.39238474,4.71880596 9.53684794,4.93298106 L9.55583453,5.01487154 L9.39981427,5.12285898 C9.22480742,5.24074528 8.98293474,5.40182655 8.76252516,5.7230892 C8.65520964,5.86347288 8.5652297,5.98855834 8.49258534,6.10374495 M7.91444011,1.816056 L7.98722518,1.71481053 C8.38059173,1.2558864 8.62348126,1.10650784 9.34969642,0.890738815 C9.45846514,0.862522865 9.58113662,0.844265486 9.6874519,0.844265486 C9.83792892,0.844265486 9.95324011,0.877460721 10.0023087,0.933892621 L10.0374745,1.07912178 C10.026843,1.27746331 10.0104868,1.38534782 9.99903746,1.481614 C9.98513469,1.59779733 9.97204974,1.69406351 9.97204974,1.87995683 C9.95324011,2.19448168 10.0162115,2.47332166 10.0889965,2.79531544 L10.1061706,2.87000472 L10.0292964,2.93141591 C9.79703842,3.014404 9.5958572,3.16212279 9.45846514,3.36876313 L9.45028704,3.37706194 L9.2810004,3.25174993 C9.13706586,3.13639649 8.95142302,2.9836984 8.63820184,2.8882621 C8.4362028,2.80610389 8.26528054,2.76212021 8.12788848,2.72477557 C7.93815659,2.67415283 7.81139606,2.64012772 7.71571231,2.54386154 C7.53988319,2.38784393 7.64701628,2.1936518 7.91444011,1.816056 M11.2068426,4.07157137 C11.2068426,4.46405179 10.8928255,4.78417109 10.5089416,4.78417109 C10.1350386,4.78417109 9.83100254,4.46405179 9.83100254,4.07157137 C9.83100254,3.6845967 10.1296643,3.37706194 10.5089416,3.37706194 C10.9005032,3.37706194 11.2068426,3.6845967 11.2068426,4.07157137 M11.0704834,1.88850318 C11.0704834,1.69629688 11.0589897,1.59811358 11.0421912,1.48328903 C11.0298133,1.38676985 11.0130148,1.27776974 11.0006369,1.07391457 L11.0377705,0.93745642 C11.0917026,0.877547962 11.2278591,0.844265486 11.4020333,0.844265486 C11.5222753,0.844265486 11.6672731,0.86340291 11.786631,0.890860953 C12.5788141,1.10553293 12.8360967,1.25530407 13.256944,1.70711369 L13.4125514,1.90264824 C13.7149248,2.26376311 13.7635521,2.38441208 13.5610857,2.54416797 C13.4877026,2.59908406 13.4125514,2.61239705 13.2710901,2.63153447 C13.103989,2.65316808 12.8758827,2.68645056 12.5549425,2.83122933 C12.2101307,2.9651913 11.9997071,3.14574873 11.8343742,3.29135957 L11.7309307,3.37706194 C11.55322,3.11163419 11.2658768,2.92525232 10.9316746,2.85119881 L10.9449366,2.79545067 C11.0262768,2.47510683 11.0881661,2.19636609 11.0704834,1.88850318 M14.0927618,3.02031918 L14.3299512,2.63890487 L13.8977769,2.55969467 C13.9340728,2.27126624 13.8378465,1.95700841 13.6099421,1.63844566 C13.0891383,0.895419596 11.9766271,0.269486859 11.1848703,0.269486859 C11.0042349,0.269486859 10.8438577,0.303065094 10.7096474,0.363333721 L10.5425174,0 L10.2513063,0.385719211 C10.0816441,0.325450584 9.89594418,0.288428427 9.70433565,0.288428427 C8.78680936,0.288428427 7.76545994,1.03403744 7.30374248,1.755539 C7.09947259,2.07754566 7.02350445,2.36941801 7.08005851,2.60016075 L6.92390178,2.64493173 L6.66223375,2.64493173 L6.92390178,3.02634604 C6.53899655,3.31219152 6.46556068,4.12753994 6.57529244,4.8800368 C6.7289169,5.89599365 7.22693025,6.91797736 7.99927299,6.89645285 L7.99927299,7.34674559 L8.3774255,7.24170598 L8.49137771,7.52841245 C8.82563752,7.99334185 9.79296515,8.16123303 10.5180388,8.16123303 C11.3216129,8.16123303 11.9589012,7.97440028 12.2239456,7.66789127 L12.3615323,7.39754343 L12.8730511,7.56199068 L12.8257821,7.06692696 C13.6099421,7.04540245 14.1349663,6.16806345 14.3594944,5.34582718 C14.589931,4.51153719 14.5916192,3.46286309 14.0927618,3.02031918"
              fill="#1B63B7"
            />
            <mask id="mask-6" fill="white">
              <polygon points="0 15.5805358 21.4005666 15.5805358 21.4005666 0 0 0" />
            </mask>
          </g>
          <g id="CB" transform="translate(27.000000, 40.000000)">
            <polygon
              id="Shape"
              fill="#060606"
              points="10.8880188 10 16.9889191 3.18983466 17 3.17835273 17 1 9 10"
            />
            <g id="Group" fill="#FF020D">
              <path
                id="Shape"
                d="M14.4279025,11.1617907 L17.3740289,11.1256964 C17.9982905,11.1256964 18.5084802,11.6569392 18.5084802,12.3125433 C18.5084802,12.9671629 17.9982905,13.4957806 17.3740289,13.4957806 L14.4279025,13.4957806 L14.4279025,11.1617907 L14.4279025,11.1617907 Z M7.132628,14.9471004 C9.60930457,14.9471004 11.7904597,13.622767 13.0696947,11.6175635 L13.0696947,14.9471004 L14.1652864,14.9471004 L14.4279025,14.9471004 L17.3928319,14.9471004 C18.7967938,14.9471004 19.9224704,13.7835508 19.9224704,12.3125433 C19.9224704,11.5555469 19.6200545,10.8707393 19.1358757,10.3864191 C19.6200545,9.89947393 19.9224704,9.21761944 19.9224704,8.46029499 C19.9224704,6.9889593 18.7798711,5.79325294 17.3740289,5.79325294 L16.3382936,5.79325294 L14.9249301,7.2750888 L17.3740289,7.2750888 C17.9982905,7.2750888 18.5084802,7.80633159 18.5084802,8.46029499 C18.5084802,9.11425843 17.9982905,9.64386056 17.3740289,9.64386056 L13.960333,9.64386056 L13.0759624,9.64386056 L12.266804,9.64386056 C11.4476172,11.7714566 9.45856669,13.2706833 7.132628,13.2706833 C4.0752502,13.2706833 1.60045392,10.6787831 1.60045392,7.47656074 C1.60045392,4.27663529 4.0752502,1.68243814 7.132628,1.68243814 C9.59676922,1.68243814 11.6832823,3.36804284 12.4006191,5.69842333 L13.6187441,4.36293351 C12.4911871,1.7940024 10.0085562,0.0102867768 7.132628,0.0102867768 C3.1937,0.0102867768 0,3.35327698 0,7.47656074 C0,11.6024695 3.1937,14.9471004 7.132628,14.9471004 L7.132628,14.9471004 Z"
              />
            </g>
          </g>
          <text
            id="SELECT"
            fill="#000000"
            fontFamily=".AppleSystemUIFont"
            fontSize="16"
            textAnchor="middle"
          >
            <tspan x="75" y="28" />
          </text>
        </g>
      </g>
    </g>
  </svg>
);

HardToken.propTypes = {
  height: PropTypes.number,
};

HardToken.defaultProps = {
  height: 226,
};

export default HardToken;
